import PanelMembers from "./PanelMembers";
import PreProposals from "./PreProposals";
import Proposals from "./Proposals";



const modules = [
  {
    module: PanelMembers,
    path: "/panel",
    headerText: "Panel Members",
  },
  {
    module: PreProposals,
    path: "/preproposals",
    headerText: "Pre Proposals",
  },
  {
    module: Proposals,
    path: "/proposals",
    headerText: "Proposals",
  },
];

export default modules;
